import React from "react"
import style from "./video-tile.mod.scss"
import PropTypes from "prop-types"
import { TransitionLink } from "../../helpers/pageTransitions"
import Play from "@svgs/play.svg"

const VideoTile = ({ heading, path, thumbnailUrl }) => (
  <TransitionLink className={style["video-tile"]} to={path} title={heading}>
    <div className={style["video-tile__image"]}>
      {thumbnailUrl ? (
        <img src={thumbnailUrl} alt="" loading="lazy" />
      ) : (
        <div className={style["video-tile__placeholder"]} />
      )}
      {/* <span className={style["video-tile__play"]}>
        <Play />
      </span> */}
    </div>
    <div className={style["video-tile__content"]}>
      <h2 className={style["video-tile__heading"]}>{heading}</h2>
    </div>
  </TransitionLink>
)

VideoTile.propTypes = {
  heading: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  duration: PropTypes.string
}

export default VideoTile
